import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as handlers from "../constants/handlers";
import * as config from "../constants/config";

export const addToFavorites = (tabId, product, fandeck, color, base) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_ADD_FAVORITE_FORMULA,
        params: {
            productId: product.id,
            fandeckId: fandeck.id,
            colorId: color.id,
            baseId: base.id,
            local: color.local
        }
    },
    method: handlers.ADD_FAVORITE_FORMULA,
    tabId: tabId
});

export const removeFromFavorites = (tabId, favoriteId) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_REMOVE_FAVORITE_FORMULA,
        params: {
            id: favoriteId
        }
    },
    method: handlers.REMOVE_FAVORITE_FORMULA,
    tabId: tabId
});

export const changeNumberOfPackages = (tabId, newNumber) => ({
    type: actionTypes.SET_NUMBER_OF_PACKAGES,
    payload: {
        tabId: tabId,
        numberOfPackages: newNumber
    }
});

export const selectPackage = (tabId, selectedPackage, previousPackage) => ({
    type: actionTypes.MAIN_TAB_SET_PACKAGE,
    payload: {
        tabId: tabId,
        selectedPackage: selectedPackage,
        previousPackage: previousPackage
    }
});

export const selectCustomer = (tabId, customer) => ({
    type: actionTypes.MAIN_TAB_SET_CUSTOMER,
    payload: {
        tabId: tabId,
        customer: customer
    }
});

export const addToStatistics = (tabId, packageCount) => ({
    type: actionTypes.ADD_DISPENSING_FORMULA_TO_STATS,
    payload: {
        tabId: tabId,
        packageCount: packageCount
    }
});

export const saveDirectlyToStatistics = (tabId) => ({
    type: actionTypes.SAVE_FORMULA_DIRECTLY_TO_STATISTICS,
    payload: {
        tabId: tabId
    }
});

export const getCompatibleOrdersAndOpenModal = (tabId) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_AVAILABLE_SERVERS,
        params: {
            compatibleOnly: true,
            activeOnly: true,
            orderingOnly: true
        }
    },
    method: handlers.GET_COMPATIBLE_SERVERS_AND_OPEN_MODAL,
    tabId: tabId
});

export const getCompatibleServers = (tabId) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_AVAILABLE_SERVERS,
        params: {
            compatibleOnly: true,
            activeOnly: true,
            orderingOnly: true
        }
    },
    method: handlers.LIGHT_LOAD_COMPATIBLE_SERVERS,
    tabId: tabId
});

export const initFilePreview = (tabId, fileId, online) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_FILE_INFO,
        params: {
            fileId: fileId,
            online: online
        }
    },
    method: handlers.INIT_FILE_PREVIEW,
    tabId: tabId,
    next: online
});

export const getFilePreview = (tabId, fileId, page, online) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_FILE_PAGE_PREVIEW,
        params: {
            fileId: fileId,
            page: page,
            online: online
        }
    },
    method: handlers.GET_FILE_PAGE_PREVIEW,
    tabId: tabId,
    next: online
});

export const getFileAndExport = (tabId, fileId, fileName) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_FILE,
        params: {
            fileId: fileId
        }
    },
    method: handlers.GET_FILE_AND_EXPORT,
    tabId: tabId,
    next: fileName
});

export const deleteCustomColor = (tabId, color, fandeck, product) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_DELETE_CUSTOM_FORMULA,
        params: {
            colorId: color.id,
            fandeckId: fandeck.id,
            productId: product.id
        }
    },
    method: handlers.DELETE_CUSTOM_COLOR,
    tabId: tabId
});

export const saveDispenseNote = (tabId, note) => ({
    type: actionTypes.MAIN_TAB_SAVE_DISPENSE_NOTE,
    payload: {
        tabId: tabId,
        note: note
    }
});

export const saveInternalNote = (tabId, note) => ({
    type: actionTypes.MAIN_TAB_SAVE_INTERNAL_NOTE,
    payload: {
        tabId: tabId,
        note: note
    }
});

export const deleteDispenseNote = (tabId) => ({
    type: actionTypes.MAIN_TAB_DELETE_DISPENSE_NOTE,
    payload: {
        tabId: tabId
    }
});

export const deleteInternalNote = (tabId) => ({
    type: actionTypes.MAIN_TAB_DELETE_INTERNAL_NOTE,
    payload: {
        tabId: tabId
    }
});

export const changeNumberOfLabels = (tabId, numberOfLabels) => ({
    type: actionTypes.SET_NUMBER_OF_LABELS,
    payload: {
        tabId: tabId,
        numberOfLabels: numberOfLabels
    }
});

export const getClosestColorsWithPrices = (tabId) => ({
    type: actionTypes.GET_CLOSEST_COLOR_WITH_PRICES,
    payload: {
        tabId: tabId
    }
});

export const reloadClosestColorsWithPrices = (
    tabId,
    compFandeckId,
    compColorId,
    productId,
    fandeckId,
    deltaE,
    limit,
    bipp,
    margin
) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_CLOSEST_COLOR_WITH_PRICES,
        params: {
            compColorId: compColorId,
            compFandeckId: compFandeckId,
            productId: productId,
            fandeckId: fandeckId,
            packageId: bipp.isCustom() ? null : bipp.package.id,
            customPackage: bipp.isCustom(),
            customPackageSize: bipp.isCustom() ? bipp.package.nominalAmount : null,
            customPackageunit: bipp.isCustom() ? bipp.package.unit : null,
            marginId: margin === null ? null : margin.id,
            marginLocal: margin === null ? false : margin.local,
            cie_de_2000: deltaE,
            rowCount: limit
        }
    },
    method: handlers.RELOAD_CLOSEST_COLOR_WITH_PRICES,
    tabId: tabId
});

export const getClosestColorsForMissingFormula = (
    tabId,
    compFandeckId,
    compColorId,
    productId,
    fandeckId,
    deltaE,
    limit
) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_CLOSEST_COLOR,
        params: {
            compColorId: compColorId,
            compFandeckId: compFandeckId,
            productId: productId,
            fandeckId: fandeckId,
            cieDe2000: deltaE,
            rowCount: limit
        }
    },
    method: handlers.GET_CLOSEST_COLOR_FOR_MISSING_FORMULA,
    tabId: tabId
});

export const startFormulaDispensing = (tabId) => ({
    type: actionTypes.MAIN_TAB_START_FORMULA_DISPENSING,
    payload: {
        tabId: tabId
    }
});

export const startQuickDispensing = (tabId) => ({
    type: actionTypes.MAIN_TAB_START_QUICK_DISPENSING,
    payload: {
        tabId: tabId
    }
});

export const createOrder = (tabId) => ({
    type: actionTypes.MAIN_TAB_CREATE_ORDER,
    payload: {
        tabId: tabId
    }
});

export const getBuildingSites = (tabId, customerId) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_BUILDING_SITES,
        params: {
            customerId: customerId,
            rowCount: config.MAX_ORDERS_LIMIT,
            offset: 0
        }
    },
    method: handlers.GET_BUILDING_SITES,
    tabId: tabId
});

export const getBuildingSitesWithOffset = (tabId, customerId, offset) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_BUILDING_SITES,
        params: {
            customerId: customerId,
            rowCount: config.MAX_ORDERS_LIMIT,
            offset: offset
        }
    },
    method: handlers.GET_BUILDING_SITES_WITH_OFFSET,
    tabId: tabId
});

export const setBuildingSite = (tabId, buildingSite) => ({
    type: actionTypes.MAIN_TAB_SET_BUILDING_SITE,
    payload: {
        tabId: tabId,
        buildingSite: buildingSite
    }
});

export const deleteBuildingSite = (tabId) => ({
    type: actionTypes.MAIN_TAB_DELETE_BUILDING_SITE,
    payload: {
        tabId: tabId
    }
});
